// #ux-redesign-start: Notes rediseñada (Paso 7 — Patients)
import React, { Fragment } from "react";
import { useTranslate } from "react-translate";

import { PageContainer } from "components/ds";
import NotesHeader from "../../components/Notes/NotesHeader";
import NotesBody from "../../components/Notes/NotesBody";

const Notes = () => {
  const t = useTranslate("sidebar");

  return (
    <Fragment>
      <PageContainer title={t("notes") || "Notizen"} icon="note">
        <div style={{ display: "flex", flexDirection: "column", gap: "var(--space-4)" }}>
          <NotesHeader />
          <NotesBody />
        </div>
      </PageContainer>
    </Fragment>
  );
};

export default Notes;
// #ux-redesign-end
